<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  class="sidebar-shell-wrapper p-0 m-0"
>
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions"></slot>
  </template>

  <template #menu>
    <div class="px-3 mt-3">
      <div class="mb-2 position-relative">
        <div
          class="context-card border border-dark border-2 rounded-3 p-2 bg-collapsable-btn"
          style="cursor:pointer;"
          @click="toggle_regions_dropdown"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center gap-2">
              <i class="bi bi-geo-alt-fill"></i>
              <p v-if="!$root.sidebar_collapsed" class="mb-0 text-white text-xs mb-1">
                {{ selected_region_label }}
              </p>
            </div>

            <i
              v-if="!$root.sidebar_collapsed"
              :class="regions_dropdown_open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
            ></i>
          </div>
        </div>

        <div
          v-if="regions_dropdown_open"
          class="context-dropdown position-absolute bg-collapsable-btn border border-dark border-2 rounded-3 p-3 dropdown-panel w-100 justify-content-center align-items-center"
          style="z-index: 30;"
        >
          <div class="dropdown-scroll overflow-auto" style="max-height: 260px;">
            <div
              class="py-1 d-flex justify-content-between align-items-center text-xs"
              style="cursor:pointer;"
              @click="select_region(null)"
            >
              <div class="d-flex align-items-center gap-2">
                <small class="d-block mb-0 text-white">
                  All Regions
                </small>
              </div>
              <span v-if="selected_region === null" class="active-dot"></span>
            </div>

            <div
              v-for="region in regions_formatted"
              :key="region.id"
              class="py-1 d-flex justify-content-between align-items-center text-xs"
              style="cursor:pointer;"
              @click="select_region(region)"
            >
              <div class="d-flex align-items-center gap-2">
                <small
                  class="d-block mb-0"
                  :class="region.id === selected_region ? 'text-warning' : 'text-white'"
                >
                  {{ region.label }}
                </small>
              </div>
              <span v-if="region.id === selected_region" class="active-dot"></span>
            </div>
          </div>
        </div>
      </div>

      <template v-for="item in menu_items" :key="item.key">
        <div v-if="item.type === 'component'" class="my-2">
          <ProgrammesComponets
            main_label="Programmes"
            :active_programme_id="active_programme_id"
            :open="dropdown_open"
            icon="bi bi-briefcase"
            @toggle="toggle_dropdown"
            @open-programme="open_programme"
          />
        </div>

        <div
          v-else
          class="d-flex align-items-center gap-2 px-2 py-2 rounded-3 sidebar-menu-item"
          :class="{ active: active_menu_item === item.key }"
          @click="select_menu_item(item.key)"
          style="cursor:pointer;"
        >
          <i :class="item.icon"></i>
          <span v-if="!$root.sidebar_collapsed" class="text-xs sidebar-menu-text">
            {{ item.label }}
          </span>
        </div>
      </template>
    </div>
  </template>
</SidebarShell>
